import React from "react";
import { Checkout } from "tsi-common-react/src/apps/checkout/Checkout/index";
import { FinancingUpsellBlock } from "tsi-common-react/src/apps/checkout/FinancingUpsellBlock/index";
import { FortivaFinancingUpsellBlock } from "tsi-common-react/src/apps/checkout/FortivaFinancingUpsellBlock/index";
import { registerCheckoutCascades } from "tsi-common-react/src/apps/checkout/cascades-checkout";
import {
    PredictedDeliveryDateDisplayType,
    PreferredDeliveryDateDisplayType,
} from "tsi-common-react/src/apps/checkout/constants";
import { getPageSetting } from "tsi-common-react/src/utils/settings";

import { store } from "../../store";
import { CheckoutSidebarContent } from "./CheckoutSidebarContent";
import { PreScreenModal } from "./PreScreenModal";

// Checkout-specific store cascades, registered once when this client-only
// module loads -- before the Checkout component first renders, mirroring the
// original placement inside the checkout app mount. Loaded only on the client
// (via CheckoutApp's React.lazy import); the checkout dependency tree is not
// SSR-safe. The reactivated renderer + the client entry already wrap the
// document in the Redux Provider, so no Provider is needed here.
registerCheckoutCascades(store);

// The ErrorBoundary lives in CheckoutApp (wrapping Suspense) so it also catches
// chunk-load failures of this lazy module.
const CheckoutAppInner = (): React.JSX.Element => {
    const disableFreeShippingMessage =
        getPageSetting("disable_basket_free_shipping_message") || false;
    return (
        <Checkout
            showFinancingPreQual={getPageSetting("enable_financing") || false}
            enableSplitPay={getPageSetting("enable_split_pay") || false}
            buildPreScreenModal={(props) => {
                return <PreScreenModal {...props} />;
            }}
            getExtraSummaryContent={() => {
                return null;
            }}
            getExtraSidebarContent={() => {
                return <CheckoutSidebarContent />;
            }}
            buildFinancingUpsell={(grandTotal) => {
                return <FinancingUpsellBlock grandTotal={grandTotal} />;
            }}
            buildFortivaFinancingUpsell={(grandTotal) => {
                return <FortivaFinancingUpsellBlock grandTotal={grandTotal} />;
            }}
            disableFreeShippingMessage={disableFreeShippingMessage}
            predictedDeliveryDates={
                (getPageSetting("predicted_delivery_date_display_type") ||
                    PredictedDeliveryDateDisplayType.DISABLED) as PredictedDeliveryDateDisplayType
            }
            preferredDeliveryDates={
                (getPageSetting("preferred_delivery_date_display_type") ||
                    PreferredDeliveryDateDisplayType.DISABLED) as PreferredDeliveryDateDisplayType
            }
        />
    );
};

export default CheckoutAppInner;
